import React from 'react';
import { useDrop } from 'react-dnd';

export default function DropTargetNextToListItem(props)
{
	const bBeforeItem = props.beforeItem ? true : false;
	const dndSettings = props.dndSettings;
	const targetItemProps = props.targetItemProps;
	const handleDrop = props.handleDrop;
	const onDroppedCallback = props.onDroppedCallback;

	const [{ hovered, canDrop }, drop] = useDrop({
		accept: dndSettings.dropDefinitions.map(definition => definition.type),
		collect: monitor => ({
			hovered: monitor.isOver({ shallow: true }),
			canDrop: monitor.canDrop(),
		}),
		drop: (item, monitor) =>
		{
			//make sure the drop event wasn't already handled
			if (!monitor.didDrop())
			{
				if (!handleDrop(item) && onDroppedCallback)
				{
					onDroppedCallback(item, targetItemProps, bBeforeItem);
				}
			}
		}
	});

	const content = (
		<div 
			className={(bBeforeItem ? "dropTargetBeforeItem" : "dropTargetAfterItem")}
			data-hover={hovered && canDrop ? "true" : "false"}
		>							
		</div>
	);
	
	return drop(content);
}